import { render } from "./ReferenceRow.vue?vue&type=template&id=16875810"
import script from "./ReferenceRow.vue?vue&type=script&lang=js"
export * from "./ReferenceRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__